/*
 * @Author: 李才人
 * @Date: 2021-07-20 13:41:53
 * @LastEditors: 李才人
 * @LastEditTime: 2021-07-20 14:06:12
 * @FilePath: \m_saas_business_admin\src\dataBase\authCodeMap\assets.ts
 * @Description: 资产模块code码
 */
export const assets = {
  asset_overview: "asset_overview", //资产_资产概览

  dataAnalysis: "dataAnalysis", //数据分析
  dataAnalysis_user: "dataAnalysis_user", //数据分析_用户数据
  dataAnalysis_user_export1: "dataAnalysis_user_export1", //数据分析_趋势图导出
  dataAnalysis_user_export2: "dataAnalysis_user_export2", //数据分析_用户分析
  dataAnalysis_user_export3: "dataAnalysis_user_export3", //数据分析_用户属性分析
  dataAnalysis_user_export4: "dataAnalysis_user_export4", //数据分析_医生品牌账号分析
  dataAnalysis_user_index: "dataAnalysis_user_index", //数据分析_用户数据_用户分析
  dataAnalysis_user_index_export: "dataAnalysis_user_index_export", //数据分析_用户数据_用户分析_导出
  dataAnalysis_user_prop: "dataAnalysis_user_prop", //数据分析_用户数据_用户属性分析
  dataAnalysis_user_prop_export: "dataAnalysis_user_prop_export", //数据分析_用户数据_用户属性分析_导出
  dataAnalysis_content: "dataAnalysis_content", //数据分析_内容数据
  dataAnalysis_content_export1: "dataAnalysis_content_export1", //数据分析_内容消费分析_导出
  dataAnalysis_content_export2: "dataAnalysis_content_export2", //数据分析_内容生产分析_导出
  dataAnalysis_content_interactive: "dataAnalysis_content_interactive", //数据分析_内容数据_行为分析
  dataAnalysis_content_visit: "dataAnalysis_content_visit", //数据分析_内容数据_访问分析
};
